// extracted by mini-css-extract-plugin
export default {"role-pill":"src-components-atoms-role-pill-role-pill-module__role-pill--P3x6m","rolePill":"src-components-atoms-role-pill-role-pill-module__role-pill--P3x6m"};